import { toast } from "sonner";
import { useFenceStore } from "../store/fence-store";
import { isPolygonClosed } from "../utils/fence.utils";

export const useCompleteDrawing = () => {
	const { drawingMode, tempCircle, tempPolygon, cancelDrawing, openDataModal } =
		useFenceStore();

	const handleComplete = () => {
		if (!drawingMode) {
			return;
		}

		let area: string;
		let type: 1 | 2;

		if (drawingMode === "circle") {
			if (!tempCircle || tempCircle.radius <= 0) {
				toast.error("Desenhe um círculo no mapa.");
				return;
			}
			type = 1;
			area = `CIRCLE (${tempCircle.center[0]}, ${tempCircle.center[1]}, ${tempCircle.radius})`;
		} else {
			if (tempPolygon.length < 4 || !isPolygonClosed(tempPolygon)) {
				toast.error(
					"Desenhe um polígono fechado no mapa (mínimo três pontos)."
				);
				return;
			}
			type = 2;
			const coordsStr = tempPolygon
				.map(([lat, lon]) => `${lat} ${lon}`)
				.join(", ");
			area = `POLYGON ((${coordsStr}))`;
		}

		openDataModal({ type, area });
	};

	const handleCancel = () => {
		cancelDrawing();
	};

	return { handleComplete, handleCancel };
};
